import { KEYS } from '../util/event-keys';
export class ArrowNavigationController {
  /**
   * Handle on keydown events
   * @param event - The KeyboardEvent triggering this function.
   * @param currentFocusedElement - The current focusable item in the list of checkbox-field.
   * @param checkboxLength - Length of checkbox array
   * 1) Increment current focused index, wrapping around to the beginning if at the end
   * 2) Decrement current focused index, wrapping around to the end if at the beginning
   */

  checkboxArrowNavigation(event: KeyboardEvent, currentFocusedIndex: number, checkboxLength: number) {
    event.preventDefault();

    if (event.key === KEYS.DOWN_ARROW) {
      /* 1 */
      currentFocusedIndex = currentFocusedIndex === checkboxLength ? 0 : currentFocusedIndex + 1;
    }
    if (event.key === KEYS.UP_ARROW) {
      /* 2 */
      currentFocusedIndex = currentFocusedIndex === -1 || currentFocusedIndex === 0 ? checkboxLength : currentFocusedIndex - 1;
    }
    return currentFocusedIndex;
  }
}
